import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import { PiDotsThreeOutlineBold } from "react-icons/pi";

import {
  Avatar,
  Button,
  Flex,
  Grid,
  Statistic,
  Tag,
  Typography,
  theme,
} from "antd";
import { CiDroplet } from "react-icons/ci";
import { FaBed } from "react-icons/fa";
import { TbHeartbeat, TbWalk } from "react-icons/tb";

const { Text } = Typography; // Mantido Text
const { useToken } = theme;

export function DashboardHealthMetrics() {
  const { token } = useToken();
  const screens = Grid.useBreakpoint();

  const healthMetrics = [
    {
      Icon: FaBed,
      title: "Sleep",
      value: "9h 08m",
      percent: 8,
    },
    {
      Icon: TbHeartbeat,
      title: "Blood Pressure (bpm)",
      value: "130/90",
      percent: 2,
    },
    {
      Icon: TbWalk,
      title: "Steps",
      value: "2.324",
      percent: -21,
    },
    {
      Icon: CiDroplet,
      title: "Blood Glucose (mg/dL)",
      value: 87,
      percent: 5,
    },
  ];

  const isSmallScreen = !screens.sm;

  return (
    <Flex
      vertical
      style={{
        width: "100%",
        borderRadius: token.borderRadiusLG,
        backdropFilter: "blur(20px)",
        border: `2px solid ${token.colorBorderSecondary}`,
        padding: token.paddingMD,
        gap: token.marginSM,
        height: "100%",
      }}
    >
      {/* --- Cabeçalho --- */}
      <Flex
        align="center"
        justify="space-between"
        style={{
          width: "100%",
        }}
      >
        <Flex align="center" gap={token.marginXS}>
          <Avatar size={24} src="/assets/apple.png" />
          <Text
            style={{
              fontSize: token.fontSizeLG,
              fontWeight: token.fontWeightStrong,
              color: token.colorTextHeading,
            }}
          >
            Health Metrics
          </Text>
        </Flex>
        <Button
          type="text"
          icon={
            <PiDotsThreeOutlineBold
              color={token.colorTextDescription}
              size="16px"
            />
          }
        />
      </Flex>

      {/* --- Lista de Métricas --- */}
      <Flex
        vertical
        style={{
          width: "100%",
          height: "100%",
          gap: token.marginSM,
        }}
      >
        {healthMetrics.map((metric, index) => {
          const isPositive = metric.percent > 0;
          const suffixIcon = isPositive ? (
            <ArrowUpOutlined />
          ) : (
            <ArrowDownOutlined />
          );
          const suffixColor = isPositive ? "success" : "error";
          const percentValue = Math.abs(metric.percent);

          // --- Estilos para o Título (aplicados via Typography.Text) ---
          const titleStyles = {
            fontSize: token.fontSizeSM,
            color: token.colorTextSecondary,
            marginBottom: token.marginXXS, // Espaço abaixo do título
            whiteSpace: "normal" as const, // Garante quebra de linha ('as const' para tipagem literal)
            display: "block", // Garante comportamento de bloco para margin
          };

          return (
            <Flex
              key={index}
              align="center"
              gap={token.marginSM}
              style={{
                width: "100%",
                height: "25%",
                padding: token.paddingSM,
                borderRadius: token.borderRadius,
                border: `1px solid ${token.colorBorderSecondary}`,
                backdropFilter: "blur(20px)",
              }}
            >
              {/* --- Ícone --- */}
              <Flex
                align="center"
                justify="center"
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: token.borderRadius,
                  background: token.colorPrimary,
                  color: token.colorWhite,
                  flexShrink: 0,
                }}
              >
                <metric.Icon
                  size={token.sizeMD}
                  style={{
                    color: token.colorBgContainer,
                  }}
                />
              </Flex>

              {/* --- Estatística --- */}
              <Statistic
                // Passa o componente Text estilizado para a prop 'title'
                title={<Text style={titleStyles}>{metric.title}</Text>}
                value={metric.value}
                style={{
                  flex: 1,
                  minWidth: 0,
                }}
                // titleStyle removido daqui
                valueStyle={{
                  display: "flex",
                  flexDirection: isSmallScreen ? "column" : "row",
                  alignItems: isSmallScreen ? "flex-start" : "center",
                  gap: isSmallScreen ? token.marginXXS / 2 : token.marginXS,
                  fontSize: token.fontSizeLG,
                  lineHeight: token.lineHeightLG,
                  // Adicionado para evitar quebra de linha estranha no valor
                  whiteSpace: "nowrap",
                }}
                suffix={
                  <Tag
                    icon={suffixIcon}
                    color={suffixColor}
                    style={{ marginLeft: isSmallScreen ? 0 : token.marginXS }}
                  >
                    {percentValue}%
                  </Tag>
                }
              />
            </Flex>
          );
        })}
      </Flex>

      {/* --- Botão View All --- */}
      <Button type="primary" block>
        View All
      </Button>
    </Flex>
  );
}
